/**
 * API base URL and upload base for backend.
 * Use REACT_APP_BACKEND_URL in production (e.g. Vercel env).
 */
const BACKEND_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const API = BACKEND_BASE.replace(/\/$/, '') + '/api';
const UPLOAD_BASE = BACKEND_BASE.replace(/\/$/, '');

/**
 * Convierte una ruta de upload (ej. /uploads/xxx.jpg) en URL absoluta.
 * Si ya es http(s), la devuelve tal cual. Así todas las imágenes usan la misma base
 * y no se rompen si REACT_APP_BACKEND_URL está bien configurada.
 */
export function getUploadUrl(path) {
  if (!path || typeof path !== 'string') return '';
  const trimmed = path.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  const base = UPLOAD_BASE.endsWith('/') ? UPLOAD_BASE.slice(0, -1) : UPLOAD_BASE;
  return trimmed.startsWith('/') ? `${base}${trimmed}` : `${base}/${trimmed}`;
}

/**
 * Avatar URL: use profile image or generate from name via ui-avatars.
 */
export function getAvatarUrl(profileImage, name) {
  if (!profileImage)
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(name || 'U')}&background=ff5500&color=ffffff`;
  if (profileImage.startsWith('http')) return profileImage;
  return getUploadUrl(profileImage);
}

export { API, UPLOAD_BASE };
export default API;
